
import { Component, Vue } from 'vue-property-decorator';
import MemberCollection from '@/components/Member/MemberCollection.vue';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';

const { member } = api;

@Component({
  components: {
    MemberCollection,
  },
})
export default class UserList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private panel = 0;

  private loading = false;

  private filter = {
    q: this.$route.query.q || undefined,
    inviterPid: this.$route.query.inviterPid || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
    roleType: Util.isNullOrUndefined(this.$route.query.roleType)
      ? null
      : +this.$route.query.roleType,
    isEnabled: Util.isNullOrUndefined(this.$route.query.isEnabled)
      ? null
      : this.$route.query.isEnabled === 'true',
    authStatus: Util.isNullOrUndefined(this.$route.query.authStatus)
      ? null
      : +this.$route.query.authStatus,
    isInBlackList: Util.isNullOrUndefined(this.$route.query.isEnabled)
      ? null
      : this.$route.query.isEnabled === 'true',
    isAsc: this.$route.query.isAsc === 'true',
  };

  private roleTypes = [
    { text: '全部', value: null },
    { text: '個人', value: 1 },
    { text: '公司', value: 2 },
  ];

  private enableStatuses = [
    { text: '全部', value: null },
    { text: '啟用', value: true },
    { text: '停用', value: false },
  ];

  private authStatuses = [
    { text: '全部', value: null },
    { text: '一般會員', value: 0 },
    { text: '基本認證', value: 1 },
    { text: '實名認證', value: 2 },
  ];

  private async query() {
    const query = {
      q: this.filter.q,
      inviterPid: this.filter.inviterPid,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
      roleType: Util.isNullOrUndefined(this.filter.roleType)
        ? undefined
        : `${this.filter.roleType}`,
      isEnabled: Util.isNullOrUndefined(this.filter.isEnabled)
        ? undefined
        : `${this.filter.isEnabled}`,
      authStatus: Util.isNullOrUndefined(this.filter.authStatus)
        ? undefined
        : `${this.filter.authStatus}`,
      isInBlackList: Util.isNullOrUndefined(this.filter.isInBlackList)
        ? undefined
        : `${this.filter.isInBlackList}`,
      isAsc: `${this.filter.isAsc}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      q: undefined,
      inviterPid: undefined,
      pageSize: 20,
      pageNo: 1,
      roleType: null,
      isEnabled: null,
      authStatus: null,
      isInBlackList: null,
      isAsc: false,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await member.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserList) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
